import React from 'react';
import Error404 from '../components/error/error-display.jsx'

function NotFound() {
    return (
    <>
      <Error404 />
    </>
    );
  }
  
  export default NotFound
       
  